var exports = {
  "U": "x04b3a21e--788f19--builder-reviews",
};

module.exports = exports;
